import { IFileExplorerContext } from "@hooks/useFileExplorer";
import { createContext } from "react";

const FileExplorerContext = createContext({} as IFileExplorerContext);

export default FileExplorerContext;